import { render, staticRenderFns } from "./LmFormHeader.vue?vue&type=template&id=0a0a28d0"
import script from "./LmFormHeader.vue?vue&type=script&lang=js"
export * from "./LmFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports